import { useContext, useState, useMemo } from "react"
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Tooltip } from "@mui/material"
import { NothingToSee } from "../../empty/Index"
import { SnakeLoader } from "../../../../core/loader/SnakeLoader"
import { Visibility, DisabledByDefault, CheckBox, ContentCopy } from "@mui/icons-material"
import { Waypoint } from "react-waypoint"
import { ToolContext } from "../../../../core/context/ToolContext"
import { rqx } from "../../../../core/request/API"
import { env } from "../../../../core/Env"
import moment from "moment"

export const List = ({ loadMoreData }) => {
	const { setup_state, tool_state } = useContext(ToolContext)
    const { trainingList, trainingForm, loader, totalList, hasMore, paymentInfo, dfltPaymentInfo } = setup_state
    const { userId } = tool_state
    const [copied, setCopied] = useState(false);
	
    const handlerView = (row) => {
        trainingForm.set({...trainingForm.data, open: true, id: row.id, code: row.series_num, training_name: row.name, training_date: row.training_date, training_start: moment(row.training_start).format('HH:mm'), training_end: moment(row.training_end).format('HH:mm'), location: row.location, training_fee: row.fee_type === 1 ? 'free' : 'with_payment', training_price: row.rate, meeting_link: row.meeting_link, meeting_id: row.meeting_id, meeting_pass: row.meeting_password, confirmation: false, error: false, loader: false, method: 'update', date_today: row.date_today, active: row.active === 1 ? true : false, show_shop: row.show === 1 ? true : false, training_type: row.training_type === 1 ? 'face_to_face' : row.training_type === 2 ? 'online' : 'f2f_online'})
		const pi = row.training_fees.map(v => ({
			training_fee_id: v.training_fee_id, 
			training_fee_type_id: v.training_fee_type_id || '', 
			name: v.training_fee_type_id ? v.training_fee_type_name : v.training_type === 1 ? 'General' : v.training_type === 2 ? 'Corporate' : v.training_type === 3 ? 'CPA' : v.training_type === 4 ? 'Non-CPA' : '', 
			regularPrice: v.regular_price || '', 
			voucherCode: v.voucher || '', 
			discount: v.discount || '', 
			price: Boolean(v.regular_price) ? v.price : '', 
			voucherEnabled: Boolean(v.voucher), 
			loader: false, 
			requiredPRC: v.require_prc === null && v.training_type === 3 ? true : Boolean(v.require_prc), 
			showInShop: Boolean(v.show_in_pofshop) || v.show_in_pofshop === null,
			active: v.training_fee_type_id ? v.active : 1,
			temp_id: !v.training_fee_type_id && crypto.randomUUID(),
		}))
		paymentInfo.set(row.fee_type === 1 ? [dfltPaymentInfo.data]: pi) 
    }

    const handlerDisable = (row) => {
        trainingForm.set({...trainingForm.data, confirmation: true, active: row.active, id: row.id})
    }

    const handlerClose = () => {
        trainingForm.set({...trainingForm.data, confirmation: false})
    }

    const handlerSaving = async() => {
        trainingForm.set({...trainingForm.data, loader : true})
        let body = {
            id: trainingForm.data.id,
            active: trainingForm.data.active === 1 ? 0 : 1,
            data_status: trainingForm.data.active === 1 ? 'IsDeleted' : 'InUse',
            user_id: userId.data,
        }
        const res = await rqx.post(`<<tool>>/${env()}/setupTraining/status_update`, body)
        if (res.message === 'success') {
            trainingForm.set({...trainingForm.data, loader : false, open: false, id: '', code: '', training_name: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, method: 'create', active: 1})
            trainingList.set(trainingList.data.map(v => 
                parseInt(v.id) === parseInt(trainingForm.data.id) ?
                    {...v, active: trainingForm.data.active === 1 ? 0 : 1,}
                :
                    {...v}
            ))
        }
    }

    const headerStyle = {
        fontWeight: 'bold',
        padding: '16px',
        borderBottom: '2px solid #444',
        whiteSpace: 'nowrap',
    };

    const bodyStyle = {
        padding: '12px',
        borderBottom: '1px solid #ddd', 
        fontSize: '14px',
        whiteSpace: 'nowrap',
    };
    
    const handlerURL = (row) => {
        window.open(`${process.env.REACT_APP_URL_SHP}/psl/services/training/all?step=pay&tid=${window.btoa(row.id)}&free=${row.fee_type === 1}`, '_blank')
    }

     const handleCopy = async (link) => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500); // Reset after 1.5 sec
        } catch (err) {
            console.error('Failed to copy!', err);
        }
    };

	const memoizedTrainingList = useMemo(() => {
		return trainingList.data.map((row, idx) => (
			<TableRow key={idx}>
				{console.log('here')}
				<TableCell sx={bodyStyle}>{totalList.data - idx}</TableCell>
				{/* <TableCell sx={bodyStyle}>{trainingList.data.length - idx}</TableCell> */}
				<TableCell sx={{ ...bodyStyle, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name}</TableCell>
				<TableCell sx={{ ...bodyStyle, whiteSpace: 'nowrap', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis',cursor: 'pointer', color: '#1976d2',textDecoration: 'underline', }}
					onClick={() => handlerURL(row)} 
				>
					{`${process.env.REACT_APP_URL_SHP}/psl/services/training/all?step=pay&tid=${window.btoa(row.id)}&free=${row.fee_type === 1}`}
				</TableCell>
				<TableCell sx={bodyStyle}>{row.fee_type === 1 ? 'Free' : row.training_fees.find(v => v.regular_price)?.regular_price || "N/A"}</TableCell>
				<TableCell sx={bodyStyle}>{moment(row.training_date).format('MM/DD/YYYY')}</TableCell>
				<TableCell sx={bodyStyle}>{moment(row.training_start).format('hh:mm A')} - {moment(row.training_end).format('hh:mm A')} </TableCell>
				<TableCell sx={bodyStyle}>{row.active ? 'Active': 'Inactive'}</TableCell>
				<TableCell sx={bodyStyle}>{moment(row.created_at).format('MM/DD/YYYY')}</TableCell>
				<TableCell sx={{...bodyStyle, textAlign: 'center'}}>
					<Tooltip title="View">
						<IconButton onClick={() => handlerView(row)}>
							<Visibility  sx={{ color: '#81D4FA' }} />
						</IconButton>
					</Tooltip>
					<Tooltip title={row.active === 1 ? "Disable" : "Enable"}>
						<IconButton onClick={() => handlerDisable(row)}>
							{row.active === 1 ? <DisabledByDefault sx={{ color: '#B0BEC5' }} /> : <CheckBox sx={{color: '#80E27E'}} /> } 
						</IconButton>
					</Tooltip>
						<Tooltip title={copied ? "Copied!" : "Copy"} arrow>
						<IconButton onClick={() => handleCopy(`${process.env.REACT_APP_URL_SHP}/psl/services/training/all?step=pay&tid=${window.btoa(row.id)}&free=${row.fee_type === 1}`)}>
							<ContentCopy sx={{ fontSize: "20px" }}/>
						</IconButton>
					</Tooltip>
				</TableCell>
			</TableRow>
		))
		// eslint-disable-next-line
	}, [trainingList.data])

    return (
        <Box display="flex" flexDirection="column" pb="24px" className="overflowY">
            {
                loader.data ?
                    <Box width="100%" display="flex" justifyContent="center" alignItems="center" mt={2}>
                        <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                    </Box>
                :
                    trainingList.data.length === 0 ?
                        <NothingToSee text="No Available Training" />
                :
                    <TableContainer component={Paper}>
                        <Table stickyHeader>
                            <TableHead sx={{ backgroundColor: "#222", color: "white"  }}>
                                <TableRow>
                                    <TableCell sx={headerStyle}>No.</TableCell>
                                    <TableCell sx={headerStyle}>Promo Name</TableCell>
                                    <TableCell sx={{ ...headerStyle, maxWidth: 250 }}>Training Reg. Link</TableCell>
                                    <TableCell sx={headerStyle}>Fee</TableCell>
                                    <TableCell sx={headerStyle}>Training Date</TableCell>
                                    <TableCell sx={headerStyle}>Training Time</TableCell>
                                    <TableCell sx={headerStyle}>Status</TableCell>
                                    <TableCell sx={headerStyle}>Date Created</TableCell>
                                    <TableCell sx={{...headerStyle, textAlign: 'center'}}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
								{memoizedTrainingList}
                            </TableBody>
                        </Table>
                        {
                            hasMore.data && (
                               <Waypoint onEnter={loadMoreData}>
                                    <Box width="100%" display="flex" justifyContent="center" my={2}>
                                        <SnakeLoader bg="#009F4D" size= "10px" distance= "5px"  />
                                    </Box>
                                </Waypoint>
                            )
                        }
                    </TableContainer>
            }
            {
                !trainingForm.data.open &&
                    <Dialog open={trainingForm.data.confirmation} onClose={handlerClose}>
                        <DialogTitle sx={{ fontSize: '18px', fontWeight: 600 }}>Confirm Update</DialogTitle>
                        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>Are you sure you want to {trainingForm.data.active === 1 ? 'Disable' : 'Enable'} this training?</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handlerClose} disabled={trainingForm.data.loader}>Cancel</Button>
                            <Button onClick={handlerSaving} variant="contained" disabled={trainingForm.data.loader}>
                                {trainingForm.data.active === 1 ? 'Disable' : 'Enable'}
                            </Button>
                        </DialogActions>
                    </Dialog>
            }
        </Box>
    )
}